<template>
  <BaseForm
    :title="formTitle"
    :formData="bagPitTypeData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue';
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    bagPitTypeId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      bagPitTypeData: {
        description: ''
      },
      fields: [
        { model: 'name', label: 'Name', required: true, type: 'text' },
        { model: 'description', label: 'Description', required: false, type: 'text' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.bagPitTypeId ? `Edit Bag Pit Type` : 'Add Bag Pit Type';
    },
    submitUrl() {
      return this.bagPitTypeId ? `/api/v1/bag_pit_type/bag_pit_types/${this.bagPitTypeId}/` : '/api/v1/bag_pit_type/bag_pit_types/';
    },
    method() {
      return this.bagPitTypeId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.bagPitTypeId) {
      this.loadBagPitTypeData();
    }
  },
  methods: {
    loadBagPitTypeData() {
      axios.get(`/api/v1/bag_pit_type/bag_pit_types/${this.bagPitTypeId}/`).then(response => {
        this.bagPitTypeData = response.data;
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Bag Pit Type saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the Bag Pit Type!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
